/*
 * @Author: mayanxia
 * @Date: 2022-05-06 18:52:43
 * @Last Modified by: mayanxia
 * @Last Modified time: 2024-01-02 17:27:26
 */

<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备编号')">
              <j-input :placeholder="$t('输入设备编号模糊查询')" v-model="queryParam.deviceId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备名称')">
              <j-input :placeholder="$t('输入设备名称模糊查询')" v-model="queryParam.deviceName"></j-input>
            </a-form-item>
          </a-col>
            <a-col :span="8">
                  <a-form-model-item :label="$t('上报时间')">
                    <a-range-picker
                      v-model="date"
                      :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                      format="YYYY-MM-DD"
                      @change="onDateRangeChange"
                    />
                  </a-form-model-item>
                </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls($t('实时数据'))">{{ $t('导出') }}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" class="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>

          <a v-has="'partvalve:sendcommand'" @click="handleCommand(record)">{{ $t('命令下发') }}</a>
        </span>
      </a-table>
    </div>

    <part-valve-up-data-last-record-modal ref="modalForm" @ok="modalFormOk"></part-valve-up-data-last-record-modal>
    <part-valve-command-modal ref="commandForm" @ok="modalFormOk"></part-valve-command-modal>
    <part-elec-valve-command-modal ref="elecValveCommandForm" @ok="modalFormOk"></part-elec-valve-command-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import PartValveUpDataLastRecordModal from './modules/PartValveUpDataLastRecordModal'
  import PartValveCommandModal from './modules/PartValveCommandModal'
  import PartElecValveCommandModal from './modules/PartElecValveCommandModal'
  import JInput from '@/components/jeecg/JInput'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'PartValveUpDataLastRecordList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      PartValveUpDataLastRecordModal,
      PartValveCommandModal,
      PartElecValveCommandModal,
      JInput
    },
    data () {
      return {
        description: '阀门开度实时数据管理页面',
        url: {
          list: "/jeecg-charge/part/partValveUpDataLastRecord/list",
          exportXlsUrl: "/jeecg-charge/part/partValveUpDataLastRecord/exportXls",
        },
        dictOptions:{},
        /* 排序参数 */
        isorter:{
          column: 'createTime',
          order: 'desc',
        },
        dateType: 2
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'meterId'
          },{
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName'
          },{
            title: this.$t('安装位置'),
            align:"center",
            dataIndex: 'deviceLocation'
          },
          {
            title: this.$t('阀门开度'),
            align:"center",
            dataIndex: 'valveOpening',
            customRender: (t,r,index) => {
              return t==null?'--':t;
            }
          },
          {
            title: this.$t('阀门状态'),
            align:"center",
            dataIndex: 'meterValveStatus',
            customRender: (t,r,index) => {
              return t==null?'--':t == 1? this.$t('关阀'): this.$t('开阀');
            }
          },
          {
            title: this.$t('电压(V)'),
            align:"center",
            dataIndex: 'meterBatteryVoltage'
          },
          {
            title: this.$t('上报时间'),
            align:"center",
            dataIndex: 'updateTime'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      },
      handleCommand(record) {
        if(record.deviceType == 'EleValve') {
          // 电子阀
          this.$refs.elecValveCommandForm.edit(record);
          this.$refs.elecValveCommandForm.title = this.$t("编辑");
          this.$refs.elecValveCommandForm.disableSubmit = false;
        }else{
          this.$refs.commandForm.edit(record);
          this.$refs.commandForm.title = this.$t("编辑");
          this.$refs.commandForm.disableSubmit = false;
        }

      }
    }
  }
</script>
